import { useTranslation } from '../../../../lib/i18n';
import { ELEMENT_KIND_KEYS, elementKind, ownerElementLabel, sentReviewCountKey, type SentReviewComment } from '../../../../lib/site-review';
import styles from './SiteReviewMessage.module.css';

export function useReviewedViewLabels(title?: string) {
  const { t, i18n } = useTranslation();
  return (comments: readonly SentReviewComment[]) => ({
    heading: `${title ?? t('emailReview.sent.title')} · ${t(sentReviewCountKey(comments.length, i18n.language), { count: comments.length })}`,
    describe: (c: SentReviewComment) => ownerElementLabel(t(ELEMENT_KIND_KEYS[elementKind(c.tag)]), c.text),
  });
}

export function EmailReviewMessage({ comments, title }: { comments: readonly SentReviewComment[]; title?: string }) {
  const { t, i18n } = useTranslation();
  const count = t(sentReviewCountKey(comments.length, i18n.language), { count: comments.length });
  return (
    <div className={styles.card} data-testid="emailReviewMessage">
      <div className={`sym-type-small-medium ${styles.title}`}>
        {title ?? t('emailReview.sent.title')} · {count}
      </div>
      <ol className={styles.list}>
        {comments.map((c, i) => (
          <li key={i} className={styles.item}>
            <span dir="auto" className={styles.comment}>
              {i + 1}. {c.comment}
            </span>
            <span dir="auto" className={`sym-p3 ${styles.meta}`}>
              {ownerElementLabel(t(ELEMENT_KIND_KEYS[elementKind(c.tag)]), c.text)}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
